module.exports = __webpack_public_path__ + "media/images/font/Gustavo-Italic-30ed3dece97800b116485f693b8b2d19.woff2";